import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchAutosuggest, initialState } from '../services/fetchAutosuggest'

export { useAutosuggest }

const queryKey = 'autosuggest'

const useAutosuggest = ({
  text,
  entityType,
  isHoofdleiding,
}: {
  text: string
  entityType?: string
  isHoofdleiding?: boolean
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchAutosuggest({ text, entityType, isHoofdleiding }),
    queryKey: [queryKey, text, entityType, isHoofdleiding],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
